// extracted by mini-css-extract-plugin
module.exports = {"placeholders":"WindStationCardPlaceholders_placeholders__jANw1","placeholdersError":"WindStationCardPlaceholders_placeholdersError__SYq3w"};